import { render, staticRenderFns } from "./ProductRelated.vue?vue&type=template&id=cae7773e"
import script from "./ProductRelated.vue?vue&type=script&lang=js"
export * from "./ProductRelated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports